import React from 'react';
import { Button, Empty, Popover } from 'antd';
import { useHistory } from 'react-router-dom';

import generatePath from '~settings/routing';
import ArticleOverview from '../article-overview';

export default function Card({ title, data = [], refetch = () => {}, type }) {
  const history = useHistory();
  const articlePath = generatePath('newArticleDesign', {
    type,
    index: data.length + 1,
  });

  const handleCreateArticle = () => {
    history.push(articlePath);
  };

  return (
    <div className="article-card">
      <section className="header">
        <span className="title">{title}</span>
        <Popover
          content="Create New Article"
          trigger="hover"
          placement="topRight"
          overlayClassName="article-popover-container"
        >
          <Button type="ghost" icon="plus" onClick={handleCreateArticle} />
        </Popover>
      </section>
      <If condition={data.length === 0}>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span className="empty-desc">
              You currently don’t have any articles for this session.
            </span>
          }
        />
      </If>
      <div className="article-wrapper">
        <For of={data} each="articleData" index="index">
          <ArticleOverview
            type={type}
            articleData={articleData}
            key={index}
            sortNumber={index + 1}
            refetch={refetch}
          />
        </For>
      </div>
    </div>
  );
}
